import React, { useEffect, useState } from "react";
import TopNavbar from "../../components/Gnavbar";
import { toast } from "react-toastify";
import {
  getRequest,
  postWithFormData,
  deleteRequest,
} from "../../helpers/api.helper";
import { FaTrash } from "react-icons/fa";
import { UPLOAD_URL } from "../../utils/constants";

const EditPromotionBanner = () => {
  const [banner, setBanner] = useState<string | null>(null);
  const [bannerId, setBannerId] = useState<number | null>(null);
  const [image, setImage] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await getRequest("/bureau/promotional-banner");
        if (res?.success && Array.isArray(res.data) && res.data.length > 0) {
          const latestBanner = res.data[0];
          setBanner(latestBanner.image);
          setBannerId(latestBanner.id);
        }
      } catch (error) {
        toast.error("Failed to load banner");
      }
    };

    fetchBanner();
  }, []);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!image) {
      toast.warn("Please select an image");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("banner", image);

    try {
      const res = await postWithFormData(
        "/bureau/promotional-banner",
        formData
      );

      if (res?.success) {
        setBanner(res.image);
        setPreview(null);
        toast.success("Banner uploaded successfully");
      } else {
        toast.error("Upload failed");
      }
    } catch {
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!bannerId) return;

    if (!window.confirm("Are you sure you want to delete this banner?")) return;

    try {
      const res = await deleteRequest(
        `/bureau/promotional-banner/${bannerId}`,
        {}
      );
      if (res.success) {
        setBanner(null);
        setBannerId(null);
        toast.success("Banner deleted");
      } else {
        toast.error(res.message);
      }
    } catch {
      toast.error("Failed to delete banner");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">
      <TopNavbar />

      <div className="max-w-4xl mx-auto p-6">
        <h2 className="text-2xl font-semibold mb-6">Promotion Banner</h2>

        <div className="bg-white p-6 rounded-lg shadow">
          {/* Existing Banner */}
          {banner && !preview && (
            <div className="relative mb-4">
              <img
                src={`${UPLOAD_URL}/bureaus/promotional_banners/${banner}`}
                className="w-full h-48 object-cover rounded"
                alt="Banner"
              />
              <button
                onClick={handleDelete}
                className="absolute top-2 right-2 bg-red-600 text-white p-2 rounded-full"
              >
                <FaTrash />
              </button>
            </div>
          )}

          {preview && (
            <div className="mb-4">
              <img
                src={preview}
                className="w-full h-48 object-cover rounded"
                alt="Preview"
              />
            </div>
          )}

          <div className="flex items-center gap-4">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="block w-full"
            />

            <button
              onClick={handleUpload}
              disabled={loading}
              className={`px-4 py-2 rounded text-white ${
                loading ? "bg-gray-400" : "bg-purple-600 hover:bg-purple-700"
              }`}
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPromotionBanner;
